import React from 'react';

import Image from '@rsc/ui-components/tailwind/Image';
import { cn } from '@rsc/tailwind-base/utils';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';

type Props = {
  author?: string;
  slug?: string;
  className?: string;
  badge?: {
    headline?: string;
    copy?: string;
    link?: {
      linkType?: string;
      href?: string;
      internalLink?: {
        slug?: {
          current?: string;
        };
      };
    };
    icon?: {
      asset?: {
        url?: string;
      };
    };
  };
};

export default function BlogExpertBadge({
  author,
  badge,
  className,
  ...props
}: Readonly<Props>) {
  const { tt } = useUiComponentsInternationalContext();
  return (
    <div
      className={cn(
        'h-10 pl-1 pr-4 py-1 bg-background rounded-3xl border justify-start items-center gap-2 inline-flex',
        className
      )}
      {...props}
    >
      <div className="w-8 h-8 bg-cta rounded-full justify-center items-center flex">
        {badge?.icon?.asset?.url ? (
          <Image
            className="w-6 h-6 relative"
            sanityImage={badge?.icon}
            sanityRole="presentation"
          />
        ) : (
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            <rect width="32" height="32" rx="16" className="bg-cta" />
            <mask
              id="mask0_7631_36795"
              maskUnits="userSpaceOnUse"
              x="4"
              y="4"
              width="24"
              height="24"
            >
              <rect x="4" y="4" width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_7631_36795)">
              <path
                d="M13.675 17.7L14.55 14.85L12.25 13H15.1L16 10.2L16.9 13H19.75L17.425 14.85L18.3 17.7L16 15.925L13.675 17.7ZM10 27V19.275C9.36667 18.575 8.875 17.775 8.525 16.875C8.175 15.975 8 15.0167 8 14C8 11.7667 8.775 9.875 10.325 8.325C11.875 6.775 13.7667 6 16 6C18.2333 6 20.125 6.775 21.675 8.325C23.225 9.875 24 11.7667 24 14C24 15.0167 23.825 15.975 23.475 16.875C23.125 17.775 22.6333 18.575 22 19.275V27L16 25L10 27ZM16 20C17.6667 20 19.0833 19.4167 20.25 18.25C21.4167 17.0833 22 15.6667 22 14C22 12.3333 21.4167 10.9167 20.25 9.75C19.0833 8.58333 17.6667 8 16 8C14.3333 8 12.9167 8.58333 11.75 9.75C10.5833 10.9167 10 12.3333 10 14C10 15.6667 10.5833 17.0833 11.75 18.25C12.9167 19.4167 14.3333 20 16 20ZM12 24.025L16 23L20 24.025V20.925C19.4167 21.2583 18.7875 21.5208 18.1125 21.7125C17.4375 21.9042 16.7333 22 16 22C15.2667 22 14.5625 21.9042 13.8875 21.7125C13.2125 21.5208 12.5833 21.2583 12 20.925V24.025Z"
                className="fill-cta-foreground"
              />
            </g>
          </svg>
        )}
      </div>
      <div className="flex-col justify-start items-start inline-flex">
        <p className="m-0 self-stretch text-foreground text-sm font-bold leading-extraTight">
          {badge?.headline
            ? badge?.headline
            : tt(s => s.blogExpertBadgeComponent.expertBadgeLabel)}
        </p>
        <p className="m-0 self-stretch text-foreground text-sm font-normal leading-extraTight">
          {badge?.copy || author}
        </p>
      </div>
    </div>
  );
}
